import { render, staticRenderFns } from "./SubscriptionBox.vue?vue&type=template&id=6ffe2f87&scoped=true&"
import script from "./SubscriptionBox.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe2f87",
  null
  
)

export default component.exports